export default __webpack_public_path__ + "static/vm580-4746ba17554af53b2406c3092d76771e.png";